export enum TipoProdutorEnum {
   Agricultor = 1,
   Pecuarista = 2,
   Agricultor_pecuarista = 3
}
